import firebase from "firebase/app";
import "firebase/storage";

export default class StorageService {
  constructor(AuthService, TemplateService, FEService) {
    'ngInject';
    this.storage = firebase.storage();
    this.tempFolderName = "__temp_storage";
    this.as = AuthService;
    this.ts = TemplateService;
    this.fe = FEService;
  }

  async uploadTempFile(blob, fileName, ext) {
    try {
      const profile = this.as.getProfile();
      const userId = (profile && (profile.uid || profile.email)) || "Anonymous";
      const uuid = this.ts.getNewObjectId().split('-').join('');
      const filePath = `${this.tempFolderName}/${userId}/${uuid}${fileName}.${ext}`;
      const fileRef = this.storage.ref(filePath);
      await fileRef.put(blob);
      // const { data } = await this.fe.httpsCallable('getSignedTempFileUrl', filePath);
      
      return filePath;
    } catch (err) {
      console.error("Error uploading temp file: ", err);
      throw err;
    }
  }
}